import { createFileRoute } from '@tanstack/react-router';
import { SequenceSettingsContent } from '@/features/settings/components/sequences/SequenceSettingsContent';

export const Route = createFileRoute('/_dashboard/settings/sequences')({
  component: SequenceSettingsContent,
});
